import React, { useState } from "react";
import { Carousel } from "react-bootstrap";
import quizBg from "../../Assets/img/misc/quiz-bg.png";
import banner from "../../Assets/img/Masterclass/Frame 1.png";
import style from "../../Assets/css/b2bCarouselMain.module.css";

function B2BTest() {
	const [index, setIndex] = useState(0);

	const handleSelect = (selectedIndex, e) => {
		setIndex(0);
	};

	const styles = {
		text: {
			margin: "30%",
		},
	};

	return (
		<div>
			<Carousel
				// className={`${style["carousel-indicators"] ${style.active}`}
				className={`${style["carousel-indicators"]} ${style.active}`}
				style={{ zIndex: "0" }}
				controls={false}
				prevIcon={
					<span
						aria-hidden="false"
						className="carousel-control-prev-icon"
					/>
				}
				activeIndex={index}
				onSelect={handleSelect}
				slide="true"
			>
				<Carousel.Item interval={1000}>
					{/* <div  styles={{ backgroundImage:`url(${car})` }}> */}

					<img
						style={{ height: "30vw" }}
						className="d-block w-100"
						src={banner}
						alt="First slide"
					/>

					<Carousel.Caption style={{ color: "white" }}>
						<h3 style={styles.text}>First</h3>
						{/* <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p> */}
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item interval={1000}>
					<img
						style={{ height: "30vw" }}
						className="d-block w-100"
						src={banner}
						alt="Second slide"
					/>

					<Carousel.Caption>
						<h3 style={styles.text}>Second</h3>
						{/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p> */}
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item interval={1000}>
					<img
						style={{ height: "30vw" }}
						className="d-block w-100"
						src={banner}
						// src="holder.js/800x400?text=Third slide&bg=20232a"
						alt="Third slide"
					/>

					<Carousel.Caption>
						<h3 style={styles.text}>Third</h3>
						<p>
							{/* Praesent commodo cursus magna, vel scelerisque nisl consectetur. */}
						</p>
					</Carousel.Caption>
				</Carousel.Item>
			</Carousel>
		</div>
	);
}

export default B2BTest;
